/**
 * 与后端 `formatFortAgentPayMixedFusdMessage` 一致：对整段字符串做 personal_sign。
 */
export function formatFortAgentPayMixedFusdMessage(
  agentId: number,
  payTick: number
): string {
  return `paymixedfusd:${agentId}:${payTick}`;
}
